import { checkOnlineStatus } from '@/util/helper';

export const LOCATION_TYPE_ADDRESS = 'address';
export const LOCATION_TYPE_CITY = 'city';
export const LOCATION_TYPE_REGION = 'region';
export const LOCATION_TYPE_ZIP = 'zip';
export const LOCATION_TYPE_COUNTRY = 'country';

export function enabledLocations(fromConfig) {
  return [
    LOCATION_TYPE_ADDRESS,
    LOCATION_TYPE_ZIP,
    LOCATION_TYPE_CITY,
    LOCATION_TYPE_REGION,
    LOCATION_TYPE_COUNTRY,
  ].filter(loc => fromConfig.includes(loc));
}

export function getFullName(location) {
  let elName = location.name;
  if (location.type === LOCATION_TYPE_CITY && !(typeof location.region === 'undefined')) {
    elName = `${elName} (${location.region})`;
  }
  return elName;
}

export default class TargetLocation {
  constructor(type, name) {
    this.type = type;
    this.name = name;
  }
}

export function fromFacebookLocation(fbloc, coords) {
  const loc = new TargetLocation(fbloc.type, fbloc.name);

  loc.facebookId = fbloc.key;
  loc.lat = Number(coords.latitude);
  loc.lng = Number(coords.longitude);
  loc.countryCode = fbloc.country_code;
  loc.name = getFullName(fbloc);

  if (typeof loc.countryCode === 'undefined' && fbloc.type === 'country') {
    loc.countryCode = fbloc.key;
  }
  return loc;
}

export function fromFacebookMetadata(meta) {
  if (!checkOnlineStatus()) {
    return this.fromOfflineLocation(meta);
  }
  return fromFacebookLocation(meta, meta);
}

export function fromGoogle(googleloc) {
  const loc = new TargetLocation(LOCATION_TYPE_ADDRESS, googleloc.formatted_address);

  loc.facebookId = null;
  loc.lat = googleloc.geometry.location.lat();
  loc.lng = googleloc.geometry.location.lng();
  loc.countryCode = null;
  const c = googleloc.address_components.find(ac => ac.types.indexOf('country') >= 0);
  if (c && c.short_name) {
    loc.countryCode = c.short_name;
  }

  return loc;
}

export function fromOfflineLocation(location) {
  const loc = new TargetLocation(location.type, location.name);

  loc.facebookId = location.fb_city_id;
  loc.lat = Number(location.latitude);
  loc.lng = Number(location.longitude);
  loc.countryCode = location.country_code;
  loc.name = getFullName(location);

  return loc;
}



// WEBPACK FOOTER //
// ./src/models/target-location.js